import React, { useContext, useEffect, useState } from "react";
import Header from "./Navbar";
import Navigation from "./Navigation";
import { AppState } from "../App";
import { useWeb3 } from "../contexts/Web3Context";
import { useTimer } from "react-timer-hook";

const Teams = () => {
  const useAppState = useContext(AppState);
  const {
    staticContract,
    walletAddress,
    isContractReady,
    provider,
    createContract,
    signer,
    contractAddresses,
  } = useWeb3();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  useEffect(() => {
    let mounted = true;
    async function getData() {
      try {
        setIsLoading(true);
        if (!staticContract) return;

        let _team = await staticContract.getDirectTeamUsers(useAppState.id);
        setData([]);
        for (let i = 0; i < _team.length; i++) {
          setData((prev) => [
            ...prev,
            {
              sno: i + 1,
              id: Number(_team[i].id),
              Address: _team[i].account,
              started: Number(_team[i].start),
              Level: Number(_team[i].level),
              Direct: Number(_team[i].directTeam),
            },
          ]);
        }
      } catch (error) {
        console.error("Error fetching team data:", error);
      } finally {
        setIsLoading(false);
      }
    }
    if (mounted) {
      getData();
    }
    return () => {
      mounted = false;
    };
  }, [isContractReady, staticContract, walletAddress, useAppState.id]);

  return (
    <>
      <img
        src="bgimg.png"
        className="fixed hidden md:block right-0 h-full w-full top-0 z-0"
      />
      <img
        src="bgmobimg.png"
        className="fixed h-full w-full left-0 md:top-0 block md:hidden top-0 z-0"
      />

      <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative">
        <Header />
        <div className="flex justify-center w-full px-4 mt-6">
          <div className="w-full md:w-3/4">
            <Navigation />
          </div>
        </div>

        <div className="w-full flex justify-center p-4">
          <div className="mt-4 md:w-3/4 w-full">
            <div className="overflow-x-scroll w-full rounded-lg dark:text-white text-gray-800">
              <table className="w-full whitespace-nowrap">
                <thead className="bg-[#8080821a]">
                  <tr>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      SNo.
                    </th>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      ID
                    </th>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Address
                    </th>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Activation Date
                    </th>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Level
                    </th>
                    <th className="text-center font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Direct Team
                    </th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tbody>
                    <tr>
                      <td colSpan="6" className="text-center py-3 px-2">
                        Loading...
                      </td>
                    </tr>
                  </tbody>
                ) : data.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan="6" className="text-center py-3 px-2">
                        No data found
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {data.map((e, i) => {
                      return (
                        <tr key={i} className="">
                          <td className="text-center justify-center border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] py-3 px-2">
                            {e.sno}
                          </td>

                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {e.id}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {e.Address.slice(0, 7)}...{e.Address.slice(37)}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {useAppState.getUTCTime(e.started * 1000)}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {useAppState.ranks[e.Level - 1]}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {e.Direct}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Teams;
